import { Component } from '@angular/core';

@Component({
    selector: 'events-help',
    templateUrl: './events-help.component.html',
    standalone: false
})
export class EventsHelpComponent{}

